import { UserProfileRes } from '@/api/user-dashboard/queries';

export type MissingStep = 'kyc' | 'questionnaire' | 'profile';

export const MISSING_STEP_LABELS: Record<MissingStep, string> = {
  kyc: 'complete your KYC',
  questionnaire: 'complete the Investor’s Questionnaire',
  profile: 'fill out your profile',
};

type MissingStepsParams = {
  kycStatus: UserProfileRes['kycStatus'] | undefined;
  hasSubmittedQuestionnaire: UserProfileRes['hasSubmittedQuestionnaire'] | null;
  isProfileFormFilled: boolean;
};

export const getMissingSteps = ({
  kycStatus,
  hasSubmittedQuestionnaire,
  isProfileFormFilled,
}: MissingStepsParams): MissingStep[] => {
  const missingSteps: MissingStep[] = [];

  if (kycStatus !== 'APPROVED') {
    missingSteps.push('kyc');
  }

  if (hasSubmittedQuestionnaire !== true) {
    missingSteps.push('questionnaire');
  }

  if (!isProfileFormFilled) {
    missingSteps.push('profile');
  }

  return missingSteps;
};

export const getMissingStepsText = (params: MissingStepsParams) => {
  const labels = getMissingSteps(params).map((step) => MISSING_STEP_LABELS[step]);

  if (!labels.length) return '';

  if (labels.length === 1) return labels[0];

  return `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`;
};

export const getUserMissingStepsText = (
  user:
    | Pick<UserProfileRes, 'kycStatus' | 'hasSubmittedQuestionnaire' | 'profileCompleted'>
    | undefined,
): string => {
  if (!user) return '';

  return getMissingStepsText({
    kycStatus: user.kycStatus,
    hasSubmittedQuestionnaire: user.hasSubmittedQuestionnaire ?? null,
    isProfileFormFilled: !!user.profileCompleted,
  });
};
